<template>
  <div>
    <h2 class="content-block">Profile</h2>
    <div class="content-block dx-card responsive-paddings" v-if="user">
      <div class="profile-card">
        <img
          class="profile-photo"
          :src="user.picture"
          :alt="user.name"
          referrerpolicy="no-referrer"
        />
        <div class="profile-info">
          <div class="profile-name">{{ user.name }}</div>
          <div class="profile-email">{{ user.email }}</div>
        </div>
      </div>
      <div class="profile-actions">
        <dx-button
          text="Sign out"
          type="danger"
          styling-mode="outlined"
          icon="runner"
          @click="onSignOut"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import { useAuthStore } from '@/stores/auth';

const authStore = useAuthStore();
const user = computed(() => authStore.user);

function onSignOut() {
  authStore.logout();
}
</script>

<style scoped>
.profile-card {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 24px;
}

.profile-photo {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 2px solid rgba(128, 128, 128, 0.2);
  object-fit: cover;
}

.profile-name {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 4px;
}

.profile-email {
  font-size: 14px;
  opacity: 0.7;
}

.profile-actions {
  padding-top: 16px;
  border-top: 1px solid rgba(128, 128, 128, 0.15);
}
</style>
